export default {
  title: '',
  formKey: '',
  subTitle: '',
  submitBtnContent: '',
  submitUrl: '',
  needChildren: true,
  nextPage: {
    isActive: false,
    url: '',
    isInnerPage: true,
    openNewWindow: false
  },
  underLine: {
    title: {
      isShow: true,
      width: '70px', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    },
    subTitle: {
      isShow: false,
      width: 'full', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '32px',
    //   color: '#000'
    // },
    // subTitle: {
    //   fontSize: '14px',
    //   color: '#666666'
    // }
  }
}

const childProps = {
  title: '',
  itemKey: '',
  type: '',
  order: 0,
  renderMode: '',
  isRequired: true,
  options: '',
  linkSetting: {
    isUpload: false,
    url: '',
    upload: {
      fileName: '',
      fileUrl: '',
      fileKey: ''
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '16px',
    //   color: '#ffffff'
    // }
  }
}

export { childProps }
